function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.8 12h-2.4v9.2h2.4V12zm-9.6-9.2h-2.4v18.4h2.4V2.8zM4.6 6H2.2v15.2h2.4V6zM15.4.8a.8.8 0 01.8.8v20.8a.8.8 0 01-.8.8h-4.8a.8.8 0 01-.8-.8V1.6a.8.8 0 01.8-.8h4.8zM25 10a.8.8 0 01.8.8v11.6a.8.8 0 01-.8.8h-4.8a.8.8 0 01-.8-.8V10.8a.8.8 0 01.8-.8H25zM1 4a.8.8 0 00-.8.8v17.6a.8.8 0 00.8.8h4.8a.8.8 0 00.8-.8V4.8a.8.8 0 00-.8-.8H1z",
  fill: "#4FB9EF"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.2 6h2.4v15.2H2.2V6zM11.8 2.8h2.4v18.4h-2.4V2.8zM21.4 12h2.4v9.2h-2.4V12z",
  fill: "#2CC2F3"
});

var SvgSmallGraph = function SvgSmallGraph(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='26' height='24' viewBox='0 0 26 24' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M23.8002 12H21.4002V21.2H23.8002V12ZM14.2002 2.80005H11.8002V21.2H14.2002V2.80005ZM4.6002 6.00005H2.2002V21.2H4.6002V6.00005ZM15.4002 0.800049C15.842 0.800049 16.2002 1.15822 16.2002 1.60005V22.4C16.2002 22.8419 15.842 23.2 15.4002 23.2H10.6002C10.1584 23.2 9.8002 22.8419 9.8002 22.4V1.60005C9.8002 1.15822 10.1584 0.800049 10.6002 0.800049H15.4002ZM25.0002 10C25.442 10 25.8002 10.3582 25.8002 10.8V22.4C25.8002 22.8419 25.442 23.2 25.0002 23.2H20.2002C19.7584 23.2 19.4002 22.8419 19.4002 22.4V10.8C19.4002 10.3582 19.7584 10 20.2002 10H25.0002ZM1.0002 4.00005C0.558368 4.00005 0.200195 4.35822 0.200195 4.80005V22.4C0.200195 22.8419 0.558368 23.2 1.0002 23.2H5.8002C6.24202 23.2 6.6002 22.8419 6.6002 22.4V4.80005C6.6002 4.35822 6.24202 4.00005 5.8002 4.00005H1.0002Z' fill='%234FB9EF'/%3E %3Cpath d='M2.2002 6.00005H4.6002V21.2H2.2002V6.00005Z' fill='%232CC2F3'/%3E %3Cpath d='M11.8002 2.80005H14.2002V21.2H11.8002V2.80005Z' fill='%232CC2F3'/%3E %3Cpath d='M21.4002 12H23.8002V21.2H21.4002V12Z' fill='%232CC2F3'/%3E %3C/svg%3E";
export { SvgSmallGraph as ReactComponent };